import "slick-carousel/slick/slick";
import Parallax from "parallax-js";
import { CLASSES } from "@/scripts/helpers/constants";

export const mainPageDestroyAnimation = () => {
  const partnersLogos = $(".js-partners-logos-carousel");
  const efficiencySlider = $(".js-efficiency-slider-viewport");
  const efficiencySliderNav = $(".js-efficiency-slider-nav");

  partnersLogos.slick("unslick");
  partnersLogos
    .slick({
      arrows: false,
      infinite: true,
      variableWidth: true,
    });
  efficiencySliderNav.slick("unslick");
  efficiencySlider.slick("unslick");
  efficiencySlider
    .slick({
      dots: false,
      arrows: false,
      fade: true,
      cssEase: "linear"
    });
  $('.efficiency-slider-control__item.is-active').removeClass(CLASSES.IS_ACTIVE);
};

export const keyFeatures = () => {
  const sliderNavigation = $(".js-slider-key-features-navigation");
  const sliderViewport   = $(".js-slider-key-features-viewport");

  sliderNavigation.slick("unslick");
  sliderNavigation.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
  });
  sliderViewport.slick("unslick");
  sliderViewport
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
    });
  $('.slick-slide.slick-current.slick-center').addClass(CLASSES.IS_HIDDEN);
};

export const integrations = () => {
  const sliderViewport = $(".js-efficiency-slider-viewport");

  sliderViewport.slick("unslick");
  sliderViewport
    .slick({
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
    });
  $('.page-section--slider .efficiency-slider .efficiency-slider__viewport .slick-dots li').removeClass('slick-active');
};

export const updateParallax = scene => {
  const parallaxInstance = new Parallax(scene[0]);

  parallaxInstance.friction(0, 0);
};

export const stopParallax = () => {
  const scene = $(".js-decorations-key-group, .js-intro-decoration, .js-form-decoration");

  $(scene).each(function() {
    updateParallax($(this));  
  });
};
